

const apiPath = '/open-ed-graph/api/v1'
const bucketId = '60353de3340e8fe622febe04'

export {apiPath, bucketId}
